export default __webpack_public_path__ + "static/media/danta_black_male.18957854.png";